import React from "react";
import classNames from "classnames";
import Spinner from "./Spinner";
import { STATIC_STRINGS } from "../utils/Constants";
import { SIZES } from "../utils/enums";

const spinnerSizeMap = {
  [SIZES.sm]: 4,
  [SIZES.md]: 6,
};

const SpinnerButton = ({
  children,
  onClickHandler,
  loading,
  variant = "primary",
  size,
  className = "",
}: {
  children: React.ReactNode;
  onClickHandler: () => void;
  loading: boolean;
  variant?: string;
  size: SIZES;
  className?: string;
}) => {
  if (loading) {
    return (
      <button
        className={classNames(
          "btn cursor-not-allowed flex items-center justify-center",
          {
            "btn-danger-outline": variant === "error",
          },
          `btn-${variant}`,
          className
        )}
      >
        <Spinner
          size={spinnerSizeMap[size]}
          variant={`${variant === `primary` ? `white` : `neutralDark`}`}
        />
        <div className="ml-2 font-semibold">{STATIC_STRINGS.PROCESSING}</div>
      </button>
    );
  }
  return (
    <button
      className={classNames(
        "btn",
        {
          "btn-danger-outline": variant === "error",
        },
        `btn-${variant}`,
        className
      )}
      onClick={onClickHandler}
    >
      {children}
    </button>
  );
};

export default SpinnerButton;
